import { render, staticRenderFns } from "./CompanyLogoImageView.vue?vue&type=template&id=4c0c9816&scoped=true"
import script from "./CompanyLogoImageView.vue?vue&type=script&lang=js"
export * from "./CompanyLogoImageView.vue?vue&type=script&lang=js"
import style0 from "./CompanyLogoImageView.vue?vue&type=style&index=0&id=4c0c9816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0c9816",
  null
  
)

export default component.exports